import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// Import from generated schemas
const { ComplexSaleTemplateFirestoreResponse, CreateComplexSaleTemplateDto, UpdateComplexSaleTemplateDto } = schemas;

// Re-export schemas for external use
export const ComplexSaleTemplateResponseSchema = ComplexSaleTemplateFirestoreResponse;
export const CreateComplexSaleTemplateSchema = CreateComplexSaleTemplateDto;
export const UpdateComplexSaleTemplateSchema = UpdateComplexSaleTemplateDto;

export const DeleteResponseSchema = z.object({
  message: z.string(),
}).strict();

// Type exports
export type ComplexSaleTemplateResponse = z.infer<typeof ComplexSaleTemplateResponseSchema>;
export type CreateComplexSaleTemplate = z.infer<typeof CreateComplexSaleTemplateSchema>;
export type UpdateComplexSaleTemplate = z.infer<typeof UpdateComplexSaleTemplateSchema>;

// API factory function
export function createComplexSaleTemplatesApi(client: TypedApiClient) {
  return {
    getComplexSaleTemplates: (): Promise<ComplexSaleTemplateResponse[]> => {
      return client.get('/complex-sale-templates', {
        responseSchema: z.array(ComplexSaleTemplateResponseSchema),
      });
    },

    createComplexSaleTemplate: (data: CreateComplexSaleTemplate): Promise<ComplexSaleTemplateResponse> => {
      return client.post('/complex-sale-templates', {
        data,
        responseSchema: ComplexSaleTemplateResponseSchema,
      });
    },

    updateComplexSaleTemplate: (id: string, data: UpdateComplexSaleTemplate): Promise<ComplexSaleTemplateResponse> => {
      return client.patch(apiPath`/complex-sale-templates/${id}`, {
        data,
        responseSchema: ComplexSaleTemplateResponseSchema,
      });
    },

    deleteComplexSaleTemplate: (id: string): Promise<z.infer<typeof DeleteResponseSchema>> => {
      return client.delete(apiPath`/complex-sale-templates/${id}`, {
        responseSchema: DeleteResponseSchema,
      });
    },
  };
}
